import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { Container } from '../../../../../../components/SearchForm/components/AirportsWidget/components/CountryList/components/Container.js';
import { Region } from '../../../../../../components/SearchForm/components/AirportsWidget/components/Region/index.js';
import { SubRegion } from '../../../../../../components/SearchForm/components/AirportsWidget/components/SubRegion/index.js';
import { Divider } from '../../../../../../primitives/index.js';
import { SPACING_NONE } from '../../../../../../utils/spacingLegacy.js';
export const CountryList = ({
  data,
  isChecked,
  onCheck
}) => {
  const handleCheckboxChange = event => {
    event.stopPropagation();
    onCheck(event);
  };
  const handleCheckboxClick = event => {
    event.stopPropagation();
  };
  return _jsx(Container, {
    spacing: SPACING_NONE,
    children: data?.map((item, index) => index === 0 && item.subRegions.length > 0 ? _jsxs(Fragment, {
      children: [_jsx(Region, {
        item: item,
        isChecked: isChecked,
        onCheck: handleCheckboxChange,
        onCheckboxClick: handleCheckboxClick,
        onChange: handleCheckboxChange
      }), _jsx(Divider, {})]
    }, index) : _jsx(SubRegion, {
      index: index,
      item: item,
      isChecked: isChecked,
      onCheck: handleCheckboxChange,
      onCheckboxClick: handleCheckboxClick
    }, index))
  });
};